import {
  CssBaseline,
  Skeleton,
  Stack,
  ThemeProvider,
  Typography,
} from '@mui/material';
import { almaStyleArticleTheme } from '../../ArticleTheme';

export default function ArticleSkeleton() {
  return (
    <ThemeProvider theme={almaStyleArticleTheme}>
      <CssBaseline>
        <Stack
          direction='column'
          sx={{
            width: '100%',
          }}
        >
          {/* Title */}
          <Typography variant='h1'>
            <Skeleton />
          </Typography>

          {/* Body text */}
          <Typography
            variant='body1'
            sx={{
              paddingTop: 2,
              marginBottom: 2,
            }}
          >
            <Skeleton />
            <Skeleton />
            <Skeleton />
            <Skeleton />
          </Typography>
        </Stack>
      </CssBaseline>
    </ThemeProvider>
  );
}
